var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRockylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8871 26.5954C39.6081 24.5304 40 22.311 40 20C40 8.95431 31.0456 0 20 0C8.95431 0 0 8.95431 0 20C0 25.4654 2.19229 30.419 5.74548 34.0287L26.0329 13.7413L31.0417 18.75L38.8871 26.5954ZM35.2337 32.9594L26.0329 23.7588L11.6245 38.1671C14.1723 39.3435 17.0096 40 20 40C26.1017 40 31.5654 37.2675 35.2337 32.9594Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockylogo);
export default __webpack_public_path__ + "static/media/rocky logo.4124b54da9f698c6bc04d99e8fad5aa6.svg";
export { ForwardRef as ReactComponent };